
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { getAPergolasByLang } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface IPage {
    products: {
        title: string;
        slug: string;
    };
}
const PergolasPage: NextPage<IPage> = ({ products }) => {
    const { t: tr } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/pergolas", hrefLang: "x-default" },
            { href: "https://knswindows.com/pergolas", hrefLang: "en" },
            { href: "https://knsokna.pl/pergolas", hrefLang: "pl" },
            { href: "https://knsfenster.de/pergolas", hrefLang: "de" },
            { href: "https://kns-okna.eu/pergolas", hrefLang: "cs" },
            { href: "https://knsfinestre.it/pergolas", hrefLang: "it" },
            { href: "https://knsfenetres.fr/pergolas", hrefLang: "fr" },
            { href: "https://knsokna.eu/pergolas", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <Breadcrumb />
          <h1 className="bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
            {tr("products.pergolas")}
          </h1>
          {/* <CompanyLogo
          title={'company?.title'}
          logo="veka"
          content={'company?.content'}
        /> */}
          <br />
          <br />
          {tr("menu.products")}:
          <br />
          {
        // @ts-expect-error
        <Products products={products} showId/>}
          <hr />
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAPergolasByLang(LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default PergolasPage;

    async function __Next_Translate__getStaticProps__1a19cd2bf08__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pergolas/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf08__ as getStaticProps }
  